import { render, staticRenderFns } from "./Tima.vue?vue&type=template&id=d1b660fa&"
import script from "./Tima.vue?vue&type=script&lang=js&"
export * from "./Tima.vue?vue&type=script&lang=js&"
import style0 from "./Tima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports